"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertDialog = AlertDialog;
exports.AlertDialogAction = AlertDialogAction;
exports.AlertDialogCancel = AlertDialogCancel;
exports.AlertDialogContent = AlertDialogContent;
exports.AlertDialogDescription = AlertDialogDescription;
exports.AlertDialogFooter = AlertDialogFooter;
exports.AlertDialogHeader = AlertDialogHeader;
exports.AlertDialogMedia = AlertDialogMedia;
exports.AlertDialogOverlay = AlertDialogOverlay;
exports.AlertDialogPortal = AlertDialogPortal;
exports.AlertDialogTitle = AlertDialogTitle;
exports.AlertDialogTrigger = AlertDialogTrigger;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@design/lib/utils");
var _focusAutofocusField = require("@design/lib/focus-autofocus-field");
var _radixUi = require("radix-ui");
var _button = require("@design/ui/button");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className"],
  _excluded2 = ["className", "size", "onOpenAutoFocus"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className"],
  _excluded8 = ["className", "variant", "size"],
  _excluded9 = ["className", "variant", "size"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function AlertDialog(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.AlertDialog.Root, _objectSpread(_objectSpread({
    "data-slot": "alert-dialog"
  }, props), {}, {
    "data-sentry-element": "AlertDialogPrimitive.Root",
    "data-sentry-component": "AlertDialog",
    "data-sentry-source-file": "alert-dialog.tsx"
  }));
}
function AlertDialogTrigger(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.AlertDialog.Trigger, _objectSpread(_objectSpread({
    "data-slot": "alert-dialog-trigger"
  }, props), {}, {
    "data-sentry-element": "AlertDialogPrimitive.Trigger",
    "data-sentry-component": "AlertDialogTrigger",
    "data-sentry-source-file": "alert-dialog.tsx"
  }));
}
function AlertDialogPortal(_ref3) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.AlertDialog.Portal, _objectSpread(_objectSpread({
    "data-slot": "alert-dialog-portal"
  }, props), {}, {
    "data-sentry-element": "AlertDialogPrimitive.Portal",
    "data-sentry-component": "AlertDialogPortal",
    "data-sentry-source-file": "alert-dialog.tsx"
  }));
}
function AlertDialogOverlay(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.AlertDialog.Overlay, _objectSpread(_objectSpread({
    "data-slot": "alert-dialog-overlay",
    className: (0, _utils.cn)("fixed inset-0 z-modal bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0", className)
  }, props), {}, {
    "data-sentry-element": "AlertDialogPrimitive.Overlay",
    "data-sentry-component": "AlertDialogOverlay",
    "data-sentry-source-file": "alert-dialog.tsx"
  }));
}
function AlertDialogContent(_ref5) {
  var className = _ref5.className,
    _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? "default" : _ref5$size,
    onOpenAutoFocus = _ref5.onOpenAutoFocus,
    props = _objectWithoutProperties(_ref5, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(AlertDialogPortal, {
    "data-sentry-element": "AlertDialogPortal",
    "data-sentry-component": "AlertDialogContent",
    "data-sentry-source-file": "alert-dialog.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(AlertDialogOverlay, {
      "data-sentry-element": "AlertDialogOverlay",
      "data-sentry-source-file": "alert-dialog.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.AlertDialog.Content, _objectSpread(_objectSpread({
      "data-slot": "alert-dialog-content",
      onOpenAutoFocus: (0, _focusAutofocusField.focusAutofocusFieldOnOpen)(onOpenAutoFocus),
      "data-size": size,
      className: (0, _utils.cn)("group/alert-dialog-content fixed top-1/2 left-1/2 z-modal grid grid-cols-1 fit-wrap max-h-[calc(100%-2rem)] w-full -translate-x-1/2 overflow-y-auto -translate-y-1/2 gap-4 rounded-lg border border-border bg-popover p-4 text-sm text-popover-foreground shadow-md duration-100 outline-none data-[size=default]:max-w-xs data-[size=sm]:max-w-xs data-[size=default]:sm:max-w-lg data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className)
    }, props), {}, {
      "data-sentry-element": "AlertDialogPrimitive.Content",
      "data-sentry-source-file": "alert-dialog.tsx"
    }))]
  });
}
function AlertDialogHeader(_ref6) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "alert-dialog-header",
    className: (0, _utils.cn)("grid grid-rows-[auto_1fr] gap-2 has-data-[slot=alert-dialog-media]:grid-rows-[auto_auto_1fr] has-data-[slot=alert-dialog-media]:gap-x-4 sm:group-data-[size=default]/alert-dialog-content:has-data-[slot=alert-dialog-media]:grid-rows-[auto_1fr]", className)
  }, props), {}, {
    "data-sentry-component": "AlertDialogHeader",
    "data-sentry-source-file": "alert-dialog.tsx"
  }));
}
function AlertDialogFooter(_ref7) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "alert-dialog-footer",
    className: (0, _utils.cn)("flex flex-row flex-wrap justify-end gap-3 group-data-[size=sm]/alert-dialog-content:grid group-data-[size=sm]/alert-dialog-content:grid-cols-2 group-data-[size=sm]/alert-dialog-content:*:h-8", className)
  }, props), {}, {
    "data-sentry-component": "AlertDialogFooter",
    "data-sentry-source-file": "alert-dialog.tsx"
  }));
}
function AlertDialogMedia(_ref8) {
  var className = _ref8.className,
    props = _objectWithoutProperties(_ref8, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "alert-dialog-media",
    className: (0, _utils.cn)("mb-2 inline-flex size-16 items-center justify-center rounded-md bg-muted sm:group-data-[size=default]/alert-dialog-content:row-span-2 *:[svg:not([class*='size-'])]:size-8", className)
  }, props), {}, {
    "data-sentry-component": "AlertDialogMedia",
    "data-sentry-source-file": "alert-dialog.tsx"
  }));
}
function AlertDialogTitle(_ref9) {
  var className = _ref9.className,
    props = _objectWithoutProperties(_ref9, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.AlertDialog.Title, _objectSpread(_objectSpread({
    "data-slot": "alert-dialog-title",
    className: (0, _utils.cn)("fit-wrap min-w-0 text-base leading-6 font-medium text-foreground group-data-[size=sm]/alert-dialog-content:text-sm group-data-[size=sm]/alert-dialog-content:leading-5 sm:group-data-[size=default]/alert-dialog-content:group-has-data-[slot=alert-dialog-media]/alert-dialog-content:col-start-2", className)
  }, props), {}, {
    "data-sentry-element": "AlertDialogPrimitive.Title",
    "data-sentry-component": "AlertDialogTitle",
    "data-sentry-source-file": "alert-dialog.tsx"
  }));
}
function AlertDialogDescription(_ref0) {
  var className = _ref0.className,
    props = _objectWithoutProperties(_ref0, _excluded7);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.AlertDialog.Description, _objectSpread(_objectSpread({
    "data-slot": "alert-dialog-description",
    className: (0, _utils.cn)("fit-wrap min-w-0 text-sm text-pretty text-foreground group-data-[size=sm]/alert-dialog-content:text-xs group-data-[size=sm]/alert-dialog-content:leading-4 *:[a]:underline *:[a]:underline-offset-3", className)
  }, props), {}, {
    "data-sentry-element": "AlertDialogPrimitive.Description",
    "data-sentry-component": "AlertDialogDescription",
    "data-sentry-source-file": "alert-dialog.tsx"
  }));
}
function AlertDialogAction(_ref1) {
  var className = _ref1.className,
    _ref1$variant = _ref1.variant,
    variant = _ref1$variant === void 0 ? "default" : _ref1$variant,
    _ref1$size = _ref1.size,
    size = _ref1$size === void 0 ? "default" : _ref1$size,
    props = _objectWithoutProperties(_ref1, _excluded8);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    variant: variant,
    size: size,
    asChild: true,
    "data-sentry-element": "Button",
    "data-sentry-component": "AlertDialogAction",
    "data-sentry-source-file": "alert-dialog.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.AlertDialog.Action, _objectSpread(_objectSpread({
      "data-slot": "alert-dialog-action",
      className: (0, _utils.cn)(className)
    }, props), {}, {
      "data-sentry-element": "AlertDialogPrimitive.Action",
      "data-sentry-source-file": "alert-dialog.tsx"
    }))
  });
}
function AlertDialogCancel(_ref10) {
  var className = _ref10.className,
    _ref10$variant = _ref10.variant,
    variant = _ref10$variant === void 0 ? "outline" : _ref10$variant,
    _ref10$size = _ref10.size,
    size = _ref10$size === void 0 ? "default" : _ref10$size,
    props = _objectWithoutProperties(_ref10, _excluded9);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    variant: variant,
    size: size,
    asChild: true,
    "data-sentry-element": "Button",
    "data-sentry-component": "AlertDialogCancel",
    "data-sentry-source-file": "alert-dialog.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.AlertDialog.Cancel, _objectSpread(_objectSpread({
      "data-slot": "alert-dialog-cancel",
      className: (0, _utils.cn)(className)
    }, props), {}, {
      "data-sentry-element": "AlertDialogPrimitive.Cancel",
      "data-sentry-source-file": "alert-dialog.tsx"
    }))
  });
}